import moment from 'moment';
import { useEffect, useState } from 'react';

import { useDataOverviewQuery } from '~/generated/graphql';

import { TimePeriodContext } from '../context/TimePeriodContext';
import { HomeSectionDataOverview } from './HomeSectionDataOverview';

export const HomeSectionTimePeriod = () => {
  const [timePeriod, setTimePeriod] = useState('60');
  const start = moment()
    .subtract(Number(timePeriod), 'days')
    .format('YYYY-MM-DD');
  const end = moment().format('YYYY-MM-DD');

  const {
    data: dataOverview,
    loading: dataOverviewLoading,
    refetch: refetchDataOverview,
  } = useDataOverviewQuery({ variables: { start, end } });

  useEffect(() => {
    const start = moment()
      .subtract(Number(timePeriod), 'days')
      .format('YYYY-MM-DD');
    const end = moment().format('YYYY-MM-DD');

    refetchDataOverview({ start, end });
  }, [timePeriod]);

  return (
    <TimePeriodContext.Provider value={{ timePeriod, setTimePeriod }}>
      <HomeSectionDataOverview
        data={dataOverview?.rollupCounts}
        isLoading={dataOverviewLoading}
      />
    </TimePeriodContext.Provider>
  );
};
